/* Cart drawer: open, close, and stay in sync after a cart change.

   Three faults, all the same shape as the cart:add one:

   1. theme.js registers `cart:open` and `cart:close` but never toggles the drawer, so the
      <aside data-nw-cart-drawer hidden> stayed at display:none. The cart could not be
      opened at all, on any breakpoint.
   2. Nothing re-rendered the drawer after an add, so it showed its empty state even with
      items in the cart. POST /cart/add.js returned 200 and /cart.js reported item_count 1
      while the drawer still said "continue shopping".
   3. Removing [hidden] alone was not enough. The stylesheet parks the panel off-canvas with
      .nw-drawer__panel{transform:translate(100%)} and only brings it back on
      .nw-drawer.is-open .nw-drawer__panel{transform:translate(0)}. Nothing ever added that
      class, so the drawer "opened" into a full-screen overlay whose panel sat 440px past the
      right edge. The page dimmed, scrolling locked, and no cart appeared — the reported
      freeze on Add to cart. Measured at panel x=1200 on a 1200px viewport, then confirmed by
      adding is-open by hand, which slid it in.

   The class must be set AFTER the panel has a rendered starting position, or the browser
   collapses both states into one style resolution and the transition never runs. A forced
   reflow (reading offsetWidth) does that synchronously. An earlier version used nested
   requestAnimationFrame instead, which works for a real click but silently does nothing when
   the tab is not painting — rAF is throttled in background tabs, so the drawer could stay
   off-canvas exactly as in fault 3. Reflow has no such dependency.

   Re-rendering swaps the inner panel only, never the <aside> itself, so is-open, the open
   state and any element references survive a refresh.

   openCart sets overflow:hidden on <html>. Anything that opens the drawer MUST be able to
   close it, or the page is left unscrollable with nothing on screen to dismiss — which is
   how fault 3 presented. closeCart clears the class and the lock together.

   This file only reads, re-renders and toggles visibility. It never posts an add, so it
   cannot duplicate a line item. */
(function () {
  if (window.__nwCartSyncReady) return;
  window.__nwCartSyncReady = 1;

  var SECTION_ID = 'cart-drawer';
  var SEL = '#shopify-section-' + SECTION_ID;
  var DRAWER = '[data-nw-cart-drawer]';
  var PANEL = '.nw-drawer__panel';

  function drawer() { return document.querySelector(DRAWER); }
  function overlay() { return document.querySelector('[data-nw-overlay]'); }

  function isOpen() {
    var d = drawer();
    return !!d && !d.hasAttribute('hidden');
  }

  function openCart() {
    var d = drawer();
    if (!d) return;
    d.removeAttribute('hidden');
    d.setAttribute('aria-hidden', 'false');
    var o = overlay();
    if (o) o.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    // force a reflow so the panel animates in from off-canvas instead of jumping,
    // and so this does not depend on rAF firing (see note above)
    void d.offsetWidth;
    d.classList.add('is-open');
  }

  function closeCart() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('hidden', '');
    d.setAttribute('aria-hidden', 'true');
    var o = overlay();
    if (o) o.setAttribute('hidden', '');
    // must always run: leaving this set locks scrolling on the whole page
    document.documentElement.style.overflow = '';
  }

  function refreshDrawer(thenOpen) {
    return fetch('/?sections=' + SECTION_ID, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j[SECTION_ID]) return;
        var host = document.querySelector(SEL);
        if (!host) return;
        var was = isOpen();

        var doc = new DOMParser().parseFromString(j[SECTION_ID], 'text/html');
        var freshPanel = doc.querySelector(PANEL);
        var livePanel = host.querySelector(PANEL);

        if (freshPanel && livePanel) {
          // keep the <aside> so its open state and listeners survive
          livePanel.innerHTML = freshPanel.innerHTML;
        } else {
          var fresh = doc.querySelector(SEL);
          host.innerHTML = fresh ? fresh.innerHTML : j[SECTION_ID];
          if (was) openCart();
        }

        if (thenOpen) openCart();
        document.dispatchEvent(new CustomEvent('nowa:cart:rendered'));
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-nw-click="cart:open"]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-nw-click="cart:close"]')) { e.preventDefault(); closeCart(); return; }
    var d = drawer();
    if (!d || !isOpen()) return;
    // click outside the panel closes
    if (e.target.closest('[data-nw-overlay]') || (d.contains(e.target) && !e.target.closest(PANEL))) {
      closeCart();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeCart();
  });

  function isCartWrite(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;
    return /\/cart\/(add|change|update|clear)/.test(String(url || ''));
  }
  function isAdd(url) { return /\/cart\/add/.test(String(url || '')); }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var promise = nativeFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (isCartWrite(url, method)) {
        var open = isAdd(url);
        promise.then(function (res) { if (res && res.ok) refreshDrawer(open); });
      }
    } catch (e) {}
    return promise;
  };

  var xopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nwCartWrite = isCartWrite(url, method);
    this.__nwCartAdd = isAdd(url);
    return xopen.apply(this, arguments);
  };
  var xsend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__nwCartWrite) {
      var wantOpen = this.__nwCartAdd;
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) refreshDrawer(wantOpen);
      });
    }
    return xsend.apply(this, arguments);
  };
})();
